import { Box, useTheme } from "@mui/material";
import { tokens } from "../../../theme";
import SectionCard from "./SectionCard";
import DetailRow from "./DetailRow";
import TimeCell from "../../../components/TimeCell";
import { detailRowStyles as styles } from "./styles";
import {
  formatDuration,
  formatLocalDateTime,
  getTimeZoneAbbreviation,
  sentenceCase,
} from "./utils";

const HistoryCard = ({ row }) => {
  const theme = useTheme();
  const colors = tokens(theme.paletteId);
  const lastAction = row?.meta?.last_action;

  const lastActionValue = lastAction?.action
    ? `${sentenceCase(lastAction.action)} · ${formatDuration(
        lastAction.started_at,
        lastAction.ended_at
      )}`
    : null;
  const lastActionSubLine =
    lastAction?.started_at && lastAction?.ended_at
      ? `${formatLocalDateTime(lastAction.started_at)} → ${formatLocalDateTime(
          lastAction.ended_at
        )} ${getTimeZoneAbbreviation()}`
      : null;

  const hasAnyField =
    lastActionValue ||
    row?.status_changed_at ||
    row?.createdOn ||
    row?.meta?.approved_by;
  if (!hasAnyField) return null;

  return (
    <SectionCard title="History">
      <DetailRow
        label="Last action"
        value={lastActionValue}
        subLine={lastActionSubLine}
      />
      {row?.status_changed_at ? (
        <Box sx={styles.row(colors)}>
          <Box sx={styles.label(colors)}>Status changed</Box>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <TimeCell value={row.status_changed_at} />
          </Box>
        </Box>
      ) : null}
      <DetailRow
        label="Created"
        value={row?.createdOn}
        subLine={typeof row?.age === "number" ? `${row.age} d ago` : null}
      />
      <DetailRow label="Approved by" value={row?.meta?.approved_by} />
    </SectionCard>
  );
};

export default HistoryCard;
